export default __webpack_public_path__ + "static/media/listaNC.6267a196.svg";